// https://v3.docs.apostrophecms.org/guide/front-end-tips.html#register-js-to-keep-up-with-in-context-editing-events
import { saveJob, createAlerts, getFilters, markSavedJobs, getJobFilters, getSortValue} from '../../../../lib/helpers/jobHelpers';
import {
  addFilterDropdownListener,
  loadPageSize,
  removeCustomPageSize,
  setCurrentPageSize,
  setPageSizeEvent
} from "../../../../lib/helpers/common";
// import {getFilters} from '../../../job/index';
import { logWLAnalyticsEvent } from '../../../../lib/helpers/wlAnalyticsLoggerUtil';

export default () => {
  apos.util.widgetPlayers.jobSearch = {
    selector: '#job-search-filters__form',
    player: function (searchForm) {
      if (searchForm) {
        const __t = JSON.parse(searchForm.dataset.localizedValues);
        const localePrefix = searchForm.dataset.localePrefix;
        const multiSelectFilterCheckBox = searchForm.dataset.multiselectcheckboxes;


        var dropdownBtn = document.querySelector(".location-radius__button");
        var dropdownContent = document.querySelector("#contentDistance");
        var fields = document.getElementsByClassName('location-radius__field');

        if (dropdownContent) {
          for (var i = 0; i < fields.length; i++) {
            fields[i].addEventListener('click', function() {
              dropdownContent.style.display = "none";
            });
          }
          dropdownBtn.addEventListener("click", function() {
            if (dropdownContent.style.display === "block") {
              dropdownContent.style.display = "none";
            } else {
              dropdownContent.style.display = "block";
            }
          });
          document.addEventListener('click', function(event) {
            const isOutside = dropdownBtn.contains(event.target);
            if(!isOutside){
              dropdownContent.style.display = "none";          }
          });
        }

        var filterskillsParent=null;
        var theme=null;
        const data = document.getElementById("job-search-filters__form").dataset;
        if(data){
        theme = data['theme'];
        }
        /**
         * Handle expanding of filters collapse
         */
        const filterAccordions = searchForm.querySelectorAll('.filters__advanced__list__filter');
        filterAccordions.forEach((accordion) => {
                    const button = accordion.querySelector('.collapse-toggle');
          const collapse = accordion.querySelector('.filters-collapse');

          // expanding pre-selected filters
          if (button.classList.contains('active')) {
            collapse.style.maxHeight = `${collapse.scrollHeight}px`;
            collapse.style.overflow = 'visible';
          }

          button.addEventListener('click', () => {
            if (button.classList.contains('active')) {
              button.classList.remove('active');
              collapse.style.maxHeight = 0;
              collapse.style.overflow = 'hidden';
            } else {
              button.classList.add('active');
              collapse.style.maxHeight = `${collapse.scrollHeight}px`;
              setTimeout(() => collapse.style.overflow = 'visible', 200);
            }
          });
        })

        searchForm.addEventListener('submit', (e) => {
          // Avoid submitting from 'Add Content' apos button
          if(e && e.submitter && e.submitter.classList.contains('apos-button')) e.preventDefault();

          displayAlerts();
          var allInputs = searchForm.getElementsByTagName('input');
          const selected = [];

          logWLAnalyticsEvent('Job Search Completed', {
            filterParams: getJobFilters(searchForm),
          });

          for (var i = 0; i < allInputs.length; i++) {
            var input = allInputs[i];

            if (input.name && !input.value) {
              input.name = '';
            }

            if (input.name && (((input.type == 'checkbox' || input.type == 'radio') && input.checked) || input.type == 'range')) {
            console.log(input)
              if (input.type == 'range' && (input.value == 0 || input.value == '0'))
                input.name = '';
              else if (!selected.includes(`${input.name}=${input.value}`))
                selected.push(`${input.name}=${input.value}`);
              else
                input.name = '';
            }
          }
        });

        const applySearchBtn = searchForm.querySelector('.job-search-button-style');
        applySearchBtn && applySearchBtn.addEventListener('click', (e) => {
          e.preventDefault();
          onFilterChange();
        });

        const inputs = searchForm.querySelectorAll('input[type=checkbox]:not(.btn-sort):not(.job-alerts-input)');
        inputs.forEach(input => input.addEventListener('change', () => {
          const theme = searchForm.dataset['theme']
          if (theme === 'theme2') {
            return
          }
          onFilterChange();
        }));

        const rangeSliders = searchForm.querySelectorAll('input[type=range]');
        rangeSliders.forEach(rangeSlider => {
          const rangeSliderValue = searchForm.querySelector(`#${rangeSlider.id}-slider-value`.replace(/[.,\/!$%\^&\*;:{}=\`~() ]/g, (match) => `\\${match}`));
          rangeSlider.addEventListener('change', () => {
            rangeSliderValue.innerHTML = rangeSlider.value;
            onFilterChange();
          })
        });

        var pageClick=false;
        loadPageSize(searchForm);
        addPageListeners();
        addLocationListeners();
        addSortListeners();
        addPageSizeListeners();
        addMultiSelectInputListeners();
        addfilterOverlayListener();
        addFavoriteListener();
        addTheme2Listener();
        
        /**
         * We want to simulate radio buttons that can be de-selected. Instead of using actual radios, we
         * use checkboxes that de-select all other checkboxes when selected.
         */
        const customRadios = searchForm.querySelectorAll('input[type=checkbox].custom-radio');
        customRadios.forEach((customRadio) => {
          customRadio.addEventListener('click', (e) => {
            if (customRadio.checked) {
              // Select checkboxes with same class list (should contain the same filter name as part of one of the classes)
              const groupSelector = customRadio.className.split(' ').map((className) => `.${className.replace(/[.,\/!$%\^&\*;:{}=\`~() ]/g, (match) => `\\${match}`)}`).join('');
              const groupedCustomRadios = searchForm.querySelectorAll(groupSelector)
              groupedCustomRadios.forEach((groupedCustomRadio) => {
                if (customRadio != groupedCustomRadio) groupedCustomRadio.checked = false
              });
            }
          })
        })

        const clearAllButtons = searchForm.querySelectorAll('.clear-all-button');
        clearAllButtons.forEach(button => button.addEventListener('click', clearAll));

        function clearAll() {
          // Reset all text inputs
          const textInputs = searchForm.querySelectorAll('input[type=text]');
          textInputs.forEach((input) => {
            input.value = '';
          });

          // Clear google auto-suggest input
          const locationInput = searchForm.querySelector('#Facility\\.location');
          locationInput && (locationInput.value = '');

          // Remove all mutli select inputs
          const mutliSelectInputs = searchForm.querySelectorAll('.multi-select-filter-value');
          mutliSelectInputs.forEach((input) => {
            input.remove();
          });

          // Remove all multi select input display pills
          const multiSelectDisplayPills = searchForm.querySelectorAll('.filters__advanced__list__filter__applied__value');
          multiSelectDisplayPills.forEach((pill) => {
            pill.remove();
          });

          // Select all checked inputs and set their checked to false
          const inputs = searchForm.querySelectorAll('input[type=checkbox]:checked, input[type=radio]:checked');
          inputs.forEach((input) => {
            input.checked = false;
          });

          // Reset Location Radius
          const radiusField = searchForm.querySelector('.location-radius__wrapper');
          if (radiusField) {
            radiusField.classList.remove('hidden');
          }

          // Reset range slider
          const rangeInputs = searchForm.querySelectorAll('input[type=range]');
          rangeInputs.forEach((input) => {
            input.value = 0;
          });

          removeCustomPageSize(searchForm);

          onFilterChange();
        }

        function onDocumentClick(el) {
          var dropDowns = searchForm.getElementsByClassName('dropdown-fields');
          for (var i = 0; i < dropDowns.length; i++) {
            if (el.id != dropDowns[i].parentNode.querySelector('input').id && el.id!='subcategoryArrow') {
              dropDowns[i].parentNode.removeChild(dropDowns[i]);
            }
        }
        }

        document.addEventListener('click', (e) => onDocumentClick(e.target));

        const multiSearches = searchForm.querySelectorAll('.filters-collapse');

        multiSearches.forEach((multiSearch) => {
          if (!multiSearch.querySelector('.multi-search-field')) return;

          const inputField = multiSearch.querySelector('input[type=text]');
          const selectField = multiSearch.querySelector('select');
          var filterValues = [];


          const filterSlugAlias = selectField.getAttribute('data-filterslugalias');
          const filterName = selectField.getAttribute('data-filtername');
          const fieldType = selectField.getAttribute('data-fieldtype');
          const displayType = selectField.getAttribute('data-displaytype');
          if(filterSlugAlias=='category'){
            selectField.querySelectorAll('option').forEach(option =>{

              // console.log(selectField)
              var subCategoryPresent=option.getAttribute('data-subCategory')
              var value=option.getAttribute('data-value')

              if(subCategoryPresent=='true'){
                var mainCategoryValue=option.getAttribute('data-mainCategory')
                var subCategories=[]
                filterValues.forEach(filter=>{
                  if(filter.value==mainCategoryValue){
                    if(filter.subCat == undefined){
                      filter.subCat=[]

                    }
                    filter.subCat.push({value:option.value, display:option.text})
                  }

                })

              }
              else{
                filterValues.push({ value: option.value, display: option.text,subCat:subCategories })

              }
            },

            );
          }
          else{

            selectField.querySelectorAll('option').forEach(option =>{

              filterValues.push({ value: option.value, display: option.text })

            }
            );
          }
          addDropDown(multiSearch.parentNode, inputField, filterValues, filterSlugAlias, filterName, fieldType, displayType);
        });


        function closeAllLists() {
          var dropDowns = searchForm.getElementsByClassName('dropdown-fields');
          for (var i = 0; i < dropDowns.length; i++) {
              dropDowns[i].parentNode.removeChild(dropDowns[i]);
          }
        }

        function addDropDown(parent, input, arr, filterSlugAlias, filterName, fieldType, displayType) {
          let currentFocus;

          function focusOrInputHandler() {
            const value = this.value
            closeAllLists();
            currentFocus = -1;

            const dropDown = document.createElement('DIV');
            dropDown.setAttribute('id', `${this.id}-dropdown-list`);
            dropDown.setAttribute('class', 'dropdown-fields');

            this.parentNode.appendChild(dropDown);

            for (let i = 0; i < arr.length; i++) {
              if (value) {
                if (arr[i].display.toUpperCase().includes(value.toUpperCase())) {
                  const dropDownField = addDropDownField(arr[i].display, arr[i].value, filterSlugAlias, filterName, fieldType, displayType,arr[i]);
                  dropDown.appendChild(dropDownField);
                }
              } else {
                const dropDownField = addDropDownField(arr[i].display, arr[i].value, filterSlugAlias, filterName, fieldType, displayType,arr[i]);
                dropDown.appendChild(dropDownField);
                if(filterSlugAlias =='category'){
                var test=  dropDownField.querySelector('.mainCat');
                if(test){
               var isIndeterminate= test.getAttribute('data-indeterminate')
                if(isIndeterminate=='true'){
                  test.indeterminate = true;

                  }
              }
              }
            }
              }


          }

          input.addEventListener('input', focusOrInputHandler);
          input.addEventListener('focus', focusOrInputHandler);

          function addDropDownField(display, value, filterSlugAlias, filterName, fieldType, displayType,arr) {
           var multiSelectCheckBox=false
           const field = document.createElement('DIV');
            if(filterSlugAlias=='category'){
              var urlParams= getAllInputValues();
              var checked=false
              var mainCategoryChecked=false
              var params=urlParams.split('&')
              for(var i=0;i<params.length;i++){

                var values=params[i].split("=")
                if(values[0].toLowerCase().trim()==filterSlugAlias.toLowerCase()){
                    if((values[1].trim()==display.replace(/ /g,"%20").trim())|| (values[1].trim()==display.replace(/ /g,"+").trim())){
                      checked =true

                    }
                }
              }
              if(arr.subCat !=undefined && arr.subCat.length>0){
                var subCatValuesChecked=0;
                var subCatChecked=false
                var selectMainCategory
                for(i=0; i<arr.subCat.length;i++){
                  for(var k=0;k<params.length;k++){

                    var values=params[k].split("=")
                    if(values[0].toLowerCase().trim()==filterSlugAlias.toLowerCase()){
                        if(decodeURIComponent(values[1]).trim()==arr.subCat[i].display.trim()){
                          subCatChecked =true
                          subCatValuesChecked+=1

                        }
                    }
                  }
                }
              if(checked || (subCatChecked && subCatValuesChecked==arr.subCat.length)){
                mainCategoryChecked=true

              field.innerHTML = `<span id='subcategoryArrow' style='padding-right:5px'">▶</span><input id='mainCat'  type="checkbox" data-alreadychecked='true' data-indeterminate='true' data-display="${display}" data-category="main" checked=true value="${value}" id="checktest${value}"/> ${display}`;

            }
              else if(subCatChecked && subCatValuesChecked<arr.subCat.length){

              field.innerHTML = `<span id='subcategoryArrow' style='padding-right:5px'">▶</span><input type="checkbox"  class='mainCat' id='mainCat' data-display="${display}"  value="${value}" data-category="main" data-indeterminate='true'  id="checktest${value}"  /> ${display}`;

              }
              else{
                field.innerHTML = `<span id='subcategoryArrow' style='padding-right:5px'">▶</span><input type="checkbox" id='mainCat' data-display="${display}" data-category="main"  value="${value}" id="checktest${value}"/> ${display}`;

              }
                for(i=0; i<arr.subCat.length;i++){
                  checked=false
                  for(var k=0;k<params.length;k++){

                    var values=params[k].split("=")
                    if(values[0].toLowerCase().trim()==filterSlugAlias.toLowerCase()){
                        if(decodeURIComponent(values[1]).trim()==arr.subCat[i].display.trim()){
                          checked =true

                        }
                    }
                  }
                  if(checked || mainCategoryChecked){
                  field.innerHTML += `<div class='subCategory' style='display:none; padding:10px 0 0 0;'><span style='padding-left:40px'><input checked=true data-alreadychecked='true'  type="checkbox" value="${arr.subCat[i].value}" checked='true' data-category="sub" data-display="${arr.subCat[i].display}"id="checktest${arr.subCat[i].value}"/> ${arr.subCat[i].display}</span></div>`;
                  }
                  else{
                    field.innerHTML += `<div class='subCategory' style='display:none; padding:10px 0 0 0;'><span style='padding-left:40px'><input type="checkbox"  data-category="sub" value="${arr.subCat[i].value}"  data-display="${arr.subCat[i].display}"id="checktest${arr.subCat[i].value}"/> ${arr.subCat[i].display}</span></div>`;

                  }
                }

              }
              else{
                if(checked){
                field.innerHTML = `<input type="checkbox" checked=true data-alreadychecked='true' data-display="${display}" value="${value}" id="checktest${value}"/> ${display}`;
                }
                else{
                  field.innerHTML = `<input type="checkbox" data-display="${display}" value="${value}" id="checktest${value}"/> ${display}`;

                }
              }
            }
            else{

              if(displayType == 'multi-select' || displayType == 'radio'){
                var urlParams= getAllInputValues();
                var mainCategoryChecked=false
                var params=urlParams.split('&')
                for(var i=0;i<params.length;i++){
                  var values=params[i].split("=")
                  if(values[0].toLowerCase().trim()==filterSlugAlias.toLowerCase()){
                      if(decodeURIComponent(values[1].trim())==display.trim()){
                        multiSelectCheckBox =true

                      }
              }
            }
          }
            if(displayType == 'multi-select' && multiSelectFilterCheckBox=='true' && multiSelectCheckBox) {

              field.innerHTML =`<input type="checkbox" checked=true> ${display}</input>`;
              field.innerHTML += `<input type="hidden" value="${display}">`;
              field.innerHTML += `<input type="hidden" value="${value}">`;

            }
            else if(displayType == 'multi-select' && multiSelectFilterCheckBox =='true' && !multiSelectCheckBox){

              field.innerHTML =`<input type="checkbox"> ${display}</input>`;
              field.innerHTML += `<input type="hidden" value="${display}">`;
              field.innerHTML += `<input type="hidden" value="${value}">`;

            }
            else if(!multiSelectCheckBox){

              field.innerHTML =display;
              field.innerHTML += `<input type="hidden" value="${display}">`;
              field.innerHTML += `<input type="hidden" value="${value}">`;

            }
            }

            field.addEventListener('click', function (e) {
              var alreadyChecked=null
              if(e.target.id=='subcategoryArrow'){
                var subCatArrow=  field.querySelector('#subcategoryArrow');
                var subCat=field.querySelectorAll('.subCategory')
                if(subCat[0].style.display=='none'){
                subCatArrow.textContent = '▼';
                subCat.forEach(element => {
                  element.style.display='block'

                });
                return
              }
              else{
                subCatArrow.textContent = '▶';
                  subCat.forEach(element => {
                    element.style.display='none'

                  });
                  return
                }

            }
            else{
              input.value = "";
              if(filterSlugAlias=='category'){

                var test=e.target.outerHTML;

                var parser = new DOMParser();
                var doc = parser.parseFromString(test, 'text/html');
              var inputElement = doc.querySelector('input');
                var category=inputElement.getAttribute('data-category')
                if(category=='sub' || category=='main'){
                  var subCat = field.querySelectorAll('.subCategory input')
                  var count=0
                  var values=[]
                  alreadyChecked =  inputElement.getAttribute('data-alreadychecked');

                  for(var i=0;i<subCat.length;i++){
                    if(subCat[i].checked){
                      count+=1
                      var value = subCat[i].getAttribute('value');
                      values.push(value)
                    }
                  }
                  if(category=='sub'&& alreadyChecked!='true'&& subCat.length == count){
                    inputElement=field.querySelector('#mainCat')
                    removeSubCats(filterName,values)
                  }
                  else if(category=='sub' && alreadyChecked=='true' && subCat.length-1 == count){
                    var main= field.querySelector('#mainCat')
                    var value = main.getAttribute('value');
                    var removeMain=[]
                    removeMain.push(value)
                    removeSubCats(filterName,removeMain)
                    addSubCats(filterName,filterSlugAlias,fieldType,displayType,subCat,parent )
                  }
                  else if(category=='main'){
                    removeSubCats(filterName,values)
                  }
                }

              var value =inputElement.getAttribute('value');
              alreadyChecked =  inputElement.getAttribute('data-alreadychecked');
              var display= inputElement.getAttribute('data-display');
              }
              else{
                if(displayType == 'multi-select' && multiSelectFilterCheckBox == 'true'){
                  var display = this.getElementsByTagName('input')[1].value;
                  var value = this.getElementsByTagName('input')[2].value;
                }
                else{
                var display = this.getElementsByTagName('input')[0].value;
              var value = this.getElementsByTagName('input')[1].value;
                }
              }


              const type = (displayType == 'multi-select') ? 'checkbox' : 'radio';
              var selectedFields=null
              if(theme=='theme1' && filterName=='SkillType.skillTypeId' && filterskillsParent !=null){
                selectedFields = filterskillsParent.querySelector('.filters__advanced__list__filter__applied');
                filterskillsParent=null
              }
              else{
                selectedFields = parent.querySelector('.filters__advanced__list__filter__applied');

              }

              if(selectedFields && alreadyChecked==null) {
                if (type == 'radio') selectedFields.innerHTML = "";
                if(!multiSelectCheckBox){
                selectedFields.innerHTML +=
                  `<div class="filters__advanced__list__filter__applied__value multi-select__${filterName}__${value}" data-filterdata="${filterName}__${value}">
                    <input type="${type}" class="btn-check" id="${filterName}__${value}" name="${filterSlugAlias}" value="${display}" data-filtername="${filterName}" data-fieldtype="${fieldType}" data-displaytype="${displayType}" checked>
                    <label class="btn btn-outline-primary custom" for="${filterName}__${value}">${display}<svg width="12" height="12" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.05752 5.49999L9.28251 2.28249C9.42374 2.14126 9.50308 1.94971 9.50308 1.74999C9.50308 1.55026 9.42374 1.35871 9.28251 1.21749C9.14129 1.07626 8.94974 0.996918 8.75002 0.996918C8.55029 0.996918 8.35874 1.07626 8.21752 1.21749L5.00002 4.44249L1.78252 1.21749C1.64129 1.07626 1.44974 0.996918 1.25002 0.996918C1.05029 0.996918 0.858743 1.07626 0.717515 1.21749C0.576287 1.35871 0.496946 1.55026 0.496946 1.74999C0.496946 1.94971 0.576287 2.14126 0.717515 2.28249L3.94252 5.49999L0.717515 8.71749C0.647219 8.78721 0.591423 8.87016 0.553347 8.96155C0.51527 9.05295 0.495667 9.15098 0.495667 9.24999C0.495667 9.349 0.51527 9.44703 0.553347 9.53842C0.591423 9.62981 0.647219 9.71276 0.717515 9.78249C0.787237 9.85278 0.870188 9.90858 0.961583 9.94666C1.05298 9.98473 1.15101 10.0043 1.25002 10.0043C1.34902 10.0043 1.44705 9.98473 1.53845 9.94666C1.62984 9.90858 1.71279 9.85278 1.78252 9.78249L5.00002 6.55749L8.21752 9.78249C8.28724 9.85278 8.37019 9.90858 8.46158 9.94666C8.55298 9.98473 8.65101 10.0043 8.75002 10.0043C8.84902 10.0043 8.94705 9.98473 9.03845 9.94666C9.12984 9.90858 9.21279 9.85278 9.28251 9.78249C9.35281 9.71276 9.40861 9.62981 9.44668 9.53842C9.48476 9.44703 9.50436 9.349 9.50436 9.24999C9.50436 9.15098 9.48476 9.05295 9.44668 8.96155C9.40861 8.87016 9.35281 8.78721 9.28251 8.71749L6.05752 5.49999Z" fill="#333C59"></path>
                  </svg></label>
                </div>`;
                }
                else if(multiSelectFilterCheckBox =='true' && multiSelectCheckBox){
                  var test=filterName+"__"+value
                  var ele= document.getElementById(test);
                  if(ele!=null ){
                    // ele.parentNode.removeChild(ele);
                   ele.parentNode.remove();
                }
              }
                addMultiSelectInputListeners(selectedFields);
                // closeAllLists();
                onFilterChange();
              }
              else if(alreadyChecked=='true'){
                var test=filterName+"__"+value
                var ele= document.getElementById(test);
                if(ele!=null ){
                  // ele.parentNode.removeChild(ele);
                 ele.parentNode.remove();

                }
                // closeAllLists();
                // onFilterChange();

              }
              else {


              	// Added search field for theme2 filters
                selectedFields = document.getElementById(`${filterName}__${value}`);
                if(selectedFields) selectedFields.checked = true;
              }

            }
        });
        if(field.innerHTML.length>0){
            return field;
        }

          field.style.height = "0";
          field.style.padding = "0";
          field.style.visibility = "hidden";
        return field;

          }

          input.addEventListener('keydown', function (e) {
            var dropdown = searchForm.querySelector(`#${this.id}-dropdown-list`.replace(/[.,\/!$%\^&\*;:{}=\`~() ]/g, (match) => `\\${match}`));
            if (dropdown) dropdown = dropdown.getElementsByTagName('div');
            if (e.keyCode == 40) {
              currentFocus++;
              addActive(dropdown);
            } else if (e.keyCode == 38) {
              currentFocus--;
              addActive(dropdown);
            } else if (e.keyCode == 13) {
              e.preventDefault();
              if (currentFocus > -1) {
                if (dropdown) dropdown[currentFocus].click();
              }
            }
          });

          function addActive(d) {
            if (!d) return false;
            for (var i = 0; i < d.length; i++) d[i].classList.remove('dropdown-active');
            currentFocus = currentFocus >= d.length ? 0 : (currentFocus < 0 ? d.length - 1 : currentFocus);
            d[currentFocus].classList.add('dropdown-active');
          }


        }

        function addPageListeners() {
          const pageLinks = searchForm.querySelectorAll('.page-link');
          pageLinks.forEach((pageLink) => {
            const page = parseInt(pageLink.dataset['page'])

            pageLink.addEventListener('click', function () {
              pageClick=true
              if (!pageLink.classList.contains('selected')) {
                onFilterChange(page);
              }
            });
          })
          if(!pageClick){

            const re=/page\d*/
            const pageValue= re.exec(window.location)
            if(pageValue){
            var pageNumber=pageValue[0].substring(4)
            pageClick=true
            onFilterChange(pageNumber)
            }
           }
        }
        function removeSubCats(filterName,values){
          for(var i=0;i<values.length;i++){
            var test=filterName+"__"+values[i]
                var ele= document.getElementById(test);
                if(ele!=null ){
                  // ele.parentNode.removeChild(ele);
                 ele.parentNode.remove();

                }

          }
        }
        function addSubCats(filterName,filterSlugAlias,fieldType,displayType,subCat,parent ){
          var selectedFields = parent.querySelector('.filters__advanced__list__filter__applied');
          const type = (displayType == 'multi-select') ? 'checkbox' : 'radio';

          for(var i=0;i<subCat.length;i++){

            var value =subCat[i].getAttribute('value');
              var display=  subCat[i].getAttribute('data-display');
          selectedFields.innerHTML +=
          `<div class="filters__advanced__list__filter__applied__value multi-select__${filterName}__${value}" data-filterdata="${filterName}__${value}">
            <input type="${type}" class="btn-check" id="${filterName}__${value}" name="${filterSlugAlias}" value="${display}" data-filtername="${filterName}" data-fieldtype="${fieldType}" data-displaytype="${displayType}" checked>
            <label class="btn btn-outline-primary custom" for="${filterName}__${value}">${display}<svg width="12" height="12" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.05752 5.49999L9.28251 2.28249C9.42374 2.14126 9.50308 1.94971 9.50308 1.74999C9.50308 1.55026 9.42374 1.35871 9.28251 1.21749C9.14129 1.07626 8.94974 0.996918 8.75002 0.996918C8.55029 0.996918 8.35874 1.07626 8.21752 1.21749L5.00002 4.44249L1.78252 1.21749C1.64129 1.07626 1.44974 0.996918 1.25002 0.996918C1.05029 0.996918 0.858743 1.07626 0.717515 1.21749C0.576287 1.35871 0.496946 1.55026 0.496946 1.74999C0.496946 1.94971 0.576287 2.14126 0.717515 2.28249L3.94252 5.49999L0.717515 8.71749C0.647219 8.78721 0.591423 8.87016 0.553347 8.96155C0.51527 9.05295 0.495667 9.15098 0.495667 9.24999C0.495667 9.349 0.51527 9.44703 0.553347 9.53842C0.591423 9.62981 0.647219 9.71276 0.717515 9.78249C0.787237 9.85278 0.870188 9.90858 0.961583 9.94666C1.05298 9.98473 1.15101 10.0043 1.25002 10.0043C1.34902 10.0043 1.44705 9.98473 1.53845 9.94666C1.62984 9.90858 1.71279 9.85278 1.78252 9.78249L5.00002 6.55749L8.21752 9.78249C8.28724 9.85278 8.37019 9.90858 8.46158 9.94666C8.55298 9.98473 8.65101 10.0043 8.75002 10.0043C8.84902 10.0043 8.94705 9.98473 9.03845 9.94666C9.12984 9.90858 9.21279 9.85278 9.28251 9.78249C9.35281 9.71276 9.40861 9.62981 9.44668 9.53842C9.48476 9.44703 9.50436 9.349 9.50436 9.24999C9.50436 9.15098 9.48476 9.05295 9.44668 8.96155C9.40861 8.87016 9.35281 8.78721 9.28251 8.71749L6.05752 5.49999Z" fill="#333C59"></path>
          </svg></label>
        </div>`;
          }
          addMultiSelectInputListeners(selectedFields);

          onFilterChange()
          closeAllLists()

        }

        function addLocationListeners() {
          // Prevent form submission to let google autocomplete fetch location essential fields
          const locationInput = searchForm.querySelector('#Facility\\.location');
          if (locationInput) {
            locationInput.addEventListener('keypress', (e) => e.key === 'Enter' && e.preventDefault());
          }

          const radiusButton = searchForm.querySelector('.location-radius__button');
          const radiusMenu = searchForm.querySelector('.location-radius__fields');
          if (radiusButton && radiusMenu) {
            radiusButton.addEventListener('click', () => radiusMenu.classList.toggle('expand'));
            const radiusInputs = radiusMenu.querySelectorAll('input[type=radio]');
            radiusInputs.forEach(input => {
              input.addEventListener('click', () => {
                radiusButton.querySelector('span').innerHTML = input.value
                radiusMenu.classList.remove('expand');
              });
            });

            document.addEventListener('click', function (e) {
              if (!e.target.closest('.location-radius__wrapper')) {
                radiusMenu.classList.remove('expand');
              }
            });
          }
        }

        function addSortListeners() {
          const mainSelector = '.job-search__filters__sort';
          addFilterDropdownListener(searchForm, mainSelector, () => {
            logWLAnalyticsEvent('Job Sort Applied', {
              filterParams: getJobFilters(searchForm),
              sortType: getSortValue(searchForm),
            });
            onFilterChange(1, false);
          }, 'sort');
        }

        function addPageSizeListeners() {
          const pageSizeSelectors = searchForm.querySelectorAll('.page-size-selector');

          if (pageSizeSelectors) {
            pageSizeSelectors.forEach(pageSizeSelector => pageSizeSelector.addEventListener('change', e => {
              setPageSizeEvent(e, searchForm);
              onFilterChange();
            }));
          }
        }

        function addMultiSelectInputListeners(parent = document) {
          const multiSelectInputs = parent.querySelectorAll('.filters__advanced__list__filter__applied__value');
          multiSelectInputs.forEach(input => {
            input.addEventListener('click', function () { listener(this) });
          });

          function listener(el) {
            try {
            el.remove();
            onFilterChange();
            } catch (exc) {
              console.log(exc);
            }
          }
        }

        function addFavoriteListener() {
          const saveIcons = searchForm.querySelectorAll('.icon-favorite');
          saveJob(saveIcons);
        }

        function addTheme2Listener() {
          /* theme 2 --start*/
          const radioButtons = searchForm.querySelectorAll('input[type="radio"].theme2-checkbox')
          if (radioButtons.length)
          {
            radioButtons.forEach((radioElement) => {
              radioElement.addEventListener('change', () => {
                // onFilterChange()
              })
            })
          }
////theme22
          const checkBox =  searchForm.querySelectorAll('.categoryFilters input')

          checkBox.forEach((filter)=>{


              filter.addEventListener('click', () => {
                const category = filter.getAttribute('data-category');
                if(category=='main'){
                  const className = filter.getAttribute('data-value');
                  var subCatValues = searchForm.querySelectorAll('.subCategory'+className+' input');
                subCatValues.forEach(subcat=>{
                  if(filter.checked == true){
                    subcat.checked= true
                    }
                    else{
                      subcat.checked=false
                    }

                })



                }
                else{
                  const className = filter.getAttribute('data-mainvalue');

                  var mainCatValue = searchForm.querySelector('.mainCategory'+className+' input');
                  var subCatValues = searchForm.querySelectorAll('.subCategory'+className+' input');
                  var checkedSubCatCount= subCatValues.length
                  var actualLength=0
                  subCatValues.forEach(subcat=>{

                    if(subcat.checked == true){

                      actualLength+=1
                      }


                  })

                  if(actualLength == checkedSubCatCount){
                    mainCatValue.indeterminate =false
                    mainCatValue.checked=true
                  }
                  else if(actualLength< checkedSubCatCount && actualLength!=0){
                    mainCatValue.indeterminate =true
                  }
                  else{
                    mainCatValue.indeterminate =false
                    mainCatValue.checked=false
                  }

                }


            })
          })





          const radioLabels = searchForm.querySelectorAll('.theme2-filter-radio-label');
          radioLabels.forEach((radioLabel) => {
            radioLabel.addEventListener('click', (element) => {
              if (element.currentTarget.previousElementSibling.checked) {
                const currTarget = element.currentTarget.previousElementSibling
                setTimeout(() => {
                  currTarget.checked = false;
                  onFilterChange()
                })
              }
            })
          })


          const sortFilter = searchForm.querySelector('#sort-by-filter');
          if (sortFilter) {
            sortFilter.addEventListener('change', () => {
              onFilterChange()
            })
          }

          const sortFilterLg = searchForm.querySelector('#sort-by-filter-lg');
          if (sortFilterLg) {
            sortFilterLg.addEventListener('change', () => {
              onFilterChange()
            })
          }


          const moreSubOptions = searchForm.querySelectorAll('.more-sub-options')
          if(moreSubOptions){
            moreSubOptions.forEach((el) => {
              el.addEventListener('click', (e) => {
                var test=e.target.outerHTML;

                  var parser = new DOMParser();
                  var doc = parser.parseFromString(test, 'text/html');
                var inputElement = doc.querySelector('label');
                  var value=inputElement.getAttribute('data-value')
                  const subCat = searchForm.querySelectorAll('.subCategory'+value)
                                    const filter = e.target.closest('.filter')

                if (e.target.textContent === __t['jobSearch.seeMoreFilterLabel']) {
                  e.target.classList.add('more-options-expanded');
                  e.target.textContent = __t['jobSearch.seeLessFilterLabel']
                  const filter = e.target.closest('.filter')


                    if (subCat) {
                      subCat.forEach((category) => {
                        category.classList.add('show')
                          category.classList.remove('hide')

                      })

                  }
                  filter.style.maxHeight = filter.scrollHeight + "px"
                } else if (e.target.textContent === __t['jobSearch.seeLessFilterLabel']) {
                  e.target.classList.remove('more-options-expanded');
                  e.target.textContent = __t['jobSearch.seeMoreFilterLabel']


                    subCat.forEach((option, index) => {
                      if (index > 2) {
                        option.classList.remove('show')
                        option.classList.add('hide')
                      }
                    })



                }
              })
            })
          }

          const moreOptions = searchForm.querySelectorAll('.more-options')
          if (moreOptions) {
            moreOptions.forEach((el) => {
              el.addEventListener('click', (e) => {

                if (e.target.textContent === __t['jobSearch.seeMoreFilterLabel']) {
                  e.target.classList.add('more-options-expanded');
                  e.target.textContent = __t['jobSearch.seeLessFilterLabel']
                  const filter = e.target.closest('.filter')

                  if (filter) {
                    const filterOptions = filter.querySelectorAll('.filter-option')
                    filterOptions.forEach((option) => {
                      option.classList.add('show')
                      option.classList.remove('hide')
                    })
                    filter.style.maxHeight = filter.scrollHeight + "px"
                  }
                } else if (e.target.textContent === __t['jobSearch.seeLessFilterLabel']) {
                  e.target.classList.remove('more-options-expanded');
                  e.target.textContent = __t['jobSearch.seeMoreFilterLabel']
                  const filter = e.target.closest('.filter')
                  if (filter) {
                    const filterOptions = filter.querySelectorAll('.filter-option')
                    filterOptions.forEach((option, index) => {
                      if (index > 2) {
                        option.classList.remove('show')
                        option.classList.add('hide')
                      }
                    })
                  }
                }
              })
            })
          }


          var acc = searchForm.getElementsByClassName("accordion");
          if (acc) {
            var i;

            for (i = 0; i < acc.length; i++) {
              var panel = acc[i].nextElementSibling;
              panel.setAttribute('data-height', panel.scrollHeight + "px");
              if (!acc[i].classList.contains('active')) {
                panel.style.maxHeight = null;
                panel.style.display = 'none';
              } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
              }
              acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (this.classList.contains('active')) {
                  panel.style.maxHeight = panel.getAttribute('data-height');
                  panel.style.display = 'block', 200;
                } else {
                  panel.style.maxHeight = null;
                  setTimeout(() => panel.style.display = 'none', 200);
                }
              });
            }
          }

          var filterSection = searchForm.getElementsByClassName('filter-theme2')
          var jobListSection = searchForm.getElementsByClassName('joblist-theme2')

          const applyFIlter = searchForm.querySelector('.apply-filters')
          if (applyFIlter) {
            applyFIlter.addEventListener('click', () => {
              if (filterSection[0].classList.contains('col-12')) {
                filterSection[0].classList.remove('col-12')
                filterSection[0].classList.remove('p-3');
                filterSection[0].classList.add('p-0');
                filterSection[0].style.width = '0px';
                filterSection[0].style.overflow = 'hidden';
                filterSection[0].style.height = '0px';
              }
              onFilterChange()
            })
          }

          const filterToggle = searchForm.querySelector('#filter-toggle-button');
          const emailAlertSection = searchForm.querySelector('.email-alert');
          const emailAlertEnabled = searchForm.dataset['emailAlert'];
          if (filterSection && jobListSection && filterToggle) {
            jobListSection[0].classList.add(screen.width < 990 || emailAlertEnabled === 'false' ? 'col-12' : 'col-8')
            filterToggle.addEventListener('click', () => {
              if (filterSection[0].style.width === "0px") {
                filterSection[0].classList.add('col-4')
                filterSection[0].style.width = "";
                filterSection[0].style.overflow = "";
                filterSection[0].style.height = null;
                filterSection[0].classList.add('p-3')
                filterSection[0].classList.remove('p-0');
                if (emailAlertSection) {
                  emailAlertSection.classList.remove('d-lg-block');
                }
                if (emailAlertEnabled === 'false' && screen.width > 990) {
                  jobListSection[0].classList.add('col-8')
                  jobListSection[0].classList.remove('col-12')
                }

              } else {
                filterSection[0].style.width = "0px";
                filterSection[0].classList.remove('col-4')
                filterSection[0].classList.remove('p-3');
                filterSection[0].classList.add('p-0');
                filterSection[0].style.overflow = "hidden";
                filterSection[0].style.height = '0px';
                if (emailAlertSection) {
                  emailAlertSection.classList.add('d-lg-block');
                }
                if (emailAlertEnabled === 'false' && screen.width > 990) {
                  jobListSection[0].classList.remove('col-8')
                  jobListSection[0].classList.add('col-12')
                }
              }
            })
          }
          const filterToggleLg = searchForm.querySelector('#filter-toggle-button-lg')
          if (filterToggleLg && jobListSection && filterToggle) {
            filterToggleLg.addEventListener('click', () => {
              if (filterSection[0].classList.contains('col-12')) {
                filterSection[0].classList.remove('col-12')
                filterSection[0].classList.remove('p-3');
                filterSection[0].classList.add('p-0');
                filterSection[0].style.width = '0px';
                filterSection[0].style.overflow = 'hidden';
                filterSection[0].style.height = '0px';
              } else {
                filterSection[0].classList.add('col-12')
                filterSection[0].classList.add('p-3');
                filterSection[0].classList.remove('p-0');
                filterSection[0].style.width = "";
                filterSection[0].style.overflow = "";
                filterSection[0].style.height = '';
              }
            })
          }
          /* ends */
        }

        function addfilterOverlayListener() {

          const filtersOverlayCloseButton = searchForm.querySelector('#close-overlay-button');
          const filtersOverlayButton = searchForm.querySelector('#filters-overlay-button');
          const filter = searchForm.querySelector('.filters__advanced');

          if (filtersOverlayButton) {
            filtersOverlayButton.addEventListener('click', () => {
              filter.classList.add('open');
              document.querySelector('body').style.overflowY = 'hidden';
            });
          }

          if (filtersOverlayCloseButton) {
            filtersOverlayCloseButton.addEventListener('click', () => {
              filter.classList.remove('open');
              document.querySelector('body').style.overflowY = 'visible';
            });
          }
        }
        function onChangeEnableJobAlert(){
          const jobAlertsLabel = searchForm.querySelector('#job-alerts-label');
          if (jobAlertsLabel && jobAlertsLabel.innerHTML==__t['jobSearch.alerts.saved']) {
            jobAlertsLabel.innerHTML = '';
            jobAlertsToggle.classList.remove('hidden');
            const jobAlertsForm = searchForm.querySelector('.job-alerts__card.form');
            const jobAlertsSuccess = searchForm.querySelector('#job-alert-success');
            jobAlertsSuccess.classList.add('hidden');
            jobAlertsForm.classList.remove('hidden');
            searchForm.querySelector('#show-login-error-message').style.display="none"
          searchForm.querySelector('#show-error-message').innerHTML='';
          }
        }
        async function onFilterChange(page = 1, trackEvent = true) {
          toggleProgressIndicators()
          displayAlerts()
          onChangeEnableJobAlert()
          const filters = getAllInputValues();
          const widgetConfig = getWidgetConfig();
          const jobData = await getJobs(page, widgetConfig, filters);
          if(theme=='theme1'){
          const skillFilterValues = await getSkills(page,widgetConfig,filters);
          renderSkillsList(skillFilterValues)
          }
          renderJobsResults(jobData);
          toggleProgressIndicators();

          // We need to re-add event listeners since the sort and pagination elements are re-rendered
          addPageListeners();
          addFavoriteListener();

          addPageSizeListeners();
          setCurrentPageSize(searchForm);
          
          trackEvent && logWLAnalyticsEvent('Job Search Completed', {
            filterParams: getJobFilters(searchForm),
          });
        }
        async function getSkills(page, config, filters) {
          var url = 'filters'
          try {
            const searchResults = await fetch(`${localePrefix}/api/v1/job-search-widget/${url}?${page ? `page=${page}&` : ''}${config}&${filters}`);
            return searchResults.text();
          }
          catch (error) {
            console.log(error)
          }
          return

        }
        function skillListHtml(parent) {
          var child1 = parent ? parent.querySelector('.filters__advanced__list') : null;
          var child2 = child1 ? child1.querySelectorAll('.filters__advanced__list__filter') : null;
          var skillsList = null
          for (var i = 0; i < child2.length; i++) {
            if (skillsList == null) {
              var child3 = child2[i].querySelectorAll('.filters-collapse')
              skillsList = child3[0] ? child3[0].querySelector('#skillsList') : null;
              if (skillsList != null) {
                var parent = []
                parent.push([skillsList, child2[i]])
                return parent
              }

            }


          }
          return skillsList
        }
        function renderSkillsList(skills) {
          const htmlDoc = document.createElement('html')
          var parent = searchForm.querySelector('.filters__advanced');
          var skillList = null
          skillList = skillListHtml(parent)
          if (skillList && skillList.length > 0) {
            htmlDoc.innerHTML = skills
            var parent2 = htmlDoc.querySelector('.filters__advanced')
            var updatedSkillList = null
            var updatedSkillList = skillListHtml(parent2)
            var fields = updatedSkillList[0][0].querySelector('select');
            if(updatedSkillList.length>0 && fields!=null){
            skillList[0][0].innerHTML = updatedSkillList[0][0].innerHTML;
            filterskillsParent=skillList[0][1]
            const selectField = skillList[0][0].querySelector('select');
            var filterValues = [];
            selectField.querySelectorAll('option').forEach(option =>
              filterValues.push({ value: option.value, display: option.text })
            );
            const inputField = skillList[0][0].querySelector('input[type=text]')
            const filterSlugAlias = selectField.getAttribute('data-filterslugalias');
            const filterName = selectField.getAttribute('data-filtername');
            const fieldType = selectField.getAttribute('data-fieldtype');
            const displayType = selectField.getAttribute('data-displaytype');
            addDropDown(skillList.parentNode, inputField, filterValues, filterSlugAlias, filterName, fieldType, displayType);
          }
        }
      }

      function displayAlerts(){
        const alertsModal = searchForm.querySelector('#job-alerts-hide')
        if (alertsModal) {
          alertsModal.style.display='block'
        }
      }
        function toggleProgressIndicators() {
          const button = searchForm.querySelector('.job-search__filters__basic-filters > .button-wrapper > button');
          if (button) {
            const searchIcon = button.querySelector('svg');
            const spinner = button.querySelector('.spinner-border');
            if (searchIcon && spinner) {
              if (searchIcon.classList.contains('hidden')) {
                searchIcon.classList.remove('hidden');
                spinner.classList.add('hidden')
              }
              else {
                searchIcon.classList.add('hidden');
                spinner.classList.remove('hidden');
              }
            }
          }

          const placeholderList1 = searchForm.querySelector('#loading-placeholder');
          const jobsList1 = searchForm.querySelector('#jobs-list__list');
          if (placeholderList1 && jobsList1) {
            if (placeholderList1.classList.contains('hidden')) {
              placeholderList1.classList.remove('hidden');
              jobsList1.classList.add('hidden')
            } else {
              placeholderList1.classList.add('hidden');
              jobsList1.classList.remove('hidden')
            }
          }
          /* theme2 placeholder --starts */
          const placeholderList = searchForm.querySelector('#loading-placeholder-theme2');
          const jobsList = searchForm.querySelector('#jobs-list-theme2');
          if (placeholderList && jobsList) {
            if (placeholderList.classList.contains('hidden')) {
              placeholderList.classList.remove('hidden');
              jobsList.classList.add('hidden')
            } else {
              placeholderList.classList.add('hidden');
              jobsList.classList.remove('hidden')
            }
          }
          /* ends */
        }

        function getAllInputValues() {
          let selectors = 'input[type=text], input[type=checkbox]:checked, input[type=radio]:checked, input[type=range], '
          if (screen.width > 991) {
            selectors += '#sort-by-filter'
          } else {
            selectors += '#sort-by-filter-lg'
          }
          const checkedInputs = searchForm.querySelectorAll(selectors);
          const filters = [];
          var mainCategory=null;
          checkedInputs.forEach((input) => {
            if(theme=='theme2' && input.classList.contains('filterCategory')){
              var category=input.getAttribute('data-category')
              if(category=='main' && input.checked==true && input.indeterminate!=true){
                mainCategory= input.getAttribute('data-value')
                filters.push(`${input.name}=${encodeURIComponent(input.value)}`);
            }
            else if(category=='sub' && input.getAttribute('data-mainvalue')!=mainCategory){
              filters.push(`${input.name}=${encodeURIComponent(input.value)}`);
            }

          }

            else{
            if (input.type === 'range' && (input.value === "0" || input.value === 0)) return;
            if (input.value && !filters.includes(`${input.name}=${input.value}`) && input.name!=''){
              filters.push(`${input.name}=${encodeURIComponent(input.value)}`);
            }
          }

          })
          return filters.join('&');
        }

        function getWidgetConfig() {
          const widgetConfig = {
            limit: searchForm.dataset['limit'],
            allowUserDefinePageSize: searchForm.dataset['allowUserDefinePageSize'],
            referralPill: searchForm.dataset['referralpill'],
            showReferralPillOptions : searchForm.dataset['showreferralpilloptions'],
            referralText: searchForm.dataset['referraltext'],
            jobTitle: searchForm.dataset['jobtitle'],
            savedJob: searchForm.dataset['savedjob'],
            description: searchForm.dataset['description'],
            highlights: searchForm.dataset['highlights'],
            theme2Highlights: searchForm.dataset['theme2highlights'],
            theme2HighlightsCol1: searchForm.dataset['theme2highlightscol1'],
            theme: searchForm.dataset['theme'],
            displayLogo: searchForm.dataset['displaylogo']
          };
          const config = [];
          for (const [key, value] of Object.entries(widgetConfig)) {
            config.push(`${key}=${value}`);
          }
          return config.join('&');
        }

        async function getJobs(page, config, filters) {
          try {
            /**
             * Alternatively, for leveraging a built-in Apostrophe API that comes with each page to load a rendered template HTML string
             * https://v3.docs.apostrophecms.org/reference/api/pages.html#get-url-aposrefresh-1
             *
             * const searchResultsPage = await fetch(`?aposRefresh=1&${page ? `page=${page}&` : ''}${filters}`);
             *
             * Note:
             *  This allows a fetch to a relative URL, so the job search widget can be placed on any page and the same page will be requested.
             * The only problem is this requests the entire page so it is not as efficient as using a renderRoutes API.
             */

            // Calling an API route created with the job-search-widget module using renderRoutes
            // https://v3.docs.apostrophecms.org/reference/module-api/module-overview.html#renderroutes-self
            let url = 'job-search'
            if (config.includes('theme=theme2')) {
              url = 'job-search-theme2'
            }
            const searchResults = await fetch(`${localePrefix}/api/v1/job-search-widget/${url}?${page ? `page=${page}&` : ''}${config}&${filters}`);
            
            var windowLocation=window.location.href.split("?")
            if(page==1){
              window.history.replaceState(null,null,"?"+filters)
            }
            else{
              window.history.replaceState(null,null,"?"+filters+"&page"+page)
            }
            return searchResults.text();
          } catch (e) {
            console.error(e);
          }
          return;
        }

        function renderJobsResults(htmlString) {
          const htmlDoc = document.createElement('html')
          htmlDoc.innerHTML = htmlString
          searchForm.querySelector('#pagination-nav').innerHTML = htmlDoc.querySelector('#pagination-nav').innerHTML;
          const jobSearchFilterResult = searchForm.querySelector('#job-search__filters__results')
          if (jobSearchFilterResult) {
            jobSearchFilterResult.innerHTML = htmlDoc.querySelector('#job-search__filters__results').innerHTML;
          }
          const joblistList = searchForm.querySelector('#jobs-list__list')
          if (joblistList) {
            joblistList.innerHTML = htmlDoc.querySelector('#jobs-list__list').innerHTML;
          }
          const jobListTheme2 = searchForm.querySelector('#jobs-list-theme2')

          if (jobListTheme2) {
            jobListTheme2.innerHTML = htmlDoc.querySelector('#jobs-list-theme2').innerHTML
          }
          const controlsLabels = searchForm.querySelector('#job-search__filters__info__controls__labels');
          if (controlsLabels) {
            controlsLabels.innerHTML = htmlDoc.querySelector('#job-search__filters__info__controls__labels').innerHTML;
          }

          markSavedJobs();
        }

        /**
         * Job Alerts
         */
        const jobAlertsToggle = searchForm.querySelector('#job-alerts-toggle');
        if (jobAlertsToggle) {

          const jobAlertsModal = searchForm.querySelector('.job-alerts-modal');
          jobAlertsToggle.addEventListener('change', () => {
            if (jobAlertsToggle.checked) {
              jobAlertsModal.classList.remove('hidden');
            } else {
              jobAlertsModal.classList.add('hidden');
            }
          });

          const jobAlertsSubmit = searchForm.querySelector('#job-alerts-save-button');
          if (jobAlertsSubmit) {
            jobAlertsSubmit.addEventListener('click', onJobAlertsSubmit)
          }

          const jobAlertsCancel = searchForm.querySelector('#job-alerts-cancel-button');
          if (jobAlertsCancel) {
            jobAlertsCancel.addEventListener('click', onCloseJobAlertsModal)
          }

          const jobAlertsOk = searchForm.querySelector('#job-alerts-ok-button');
          if (jobAlertsOk) {
            jobAlertsOk.addEventListener('click', onFinishJobAlerts);
          }

          function onCloseJobAlertsModal() {
            if (jobAlertsModal) {
              jobAlertsToggle.checked = false;
              jobAlertsModal.classList.add('hidden');
            }
          }

          async function getJobAlertFilterParams(){
            const urlParams = getAllInputValues()
            var paramArray = urlParams.split('&')
            var req={}
            for(var i=0; i<paramArray.length;i++){
            const [key,value]=paramArray[i].split('=');
            if(req[key]){
              req[key]+= ","+decodeURIComponent(value);
            }
            else{
            req[key]=decodeURIComponent(value)
            }

            }
            var fillers= await getFilters();

            var filters = fillers.data.jobFilterMetaDataVOList
            const filterArgs = Object.entries(req);
            // Format the args for the job search API
            const formattedFilterArgs = filterArgs.map(([key, _value]) => {
              const filter = filters.find((filter) => filter.slugAlias === key);
              if (filter && _value) {
                if (filter.displayType === 'salaryrange' && (_value === 0 || _value === '0')) return;

                let value = _value;
                if (Array.isArray(_value)) {
                  const values = _value.map((x) => {
                    const selectedOption = filter.filterValues.find((option) => option.label === x)
                    if (selectedOption) {
                      return selectedOption.value
                    }
                  });
                  value = values.join(',');
                }
                else if (filter.filterValues) {
                  const selectedOption = filter.filterValues.find((option) => option.label.replace(/\n/g, '') === _value)
                  if (selectedOption) {
                    value = selectedOption.value
                  }
                }
                if (filter.slugAlias === 'category') {
                  value = JSON.stringify({ categoryIds: value.split(',') })
                }
                if (value)
                  return {
                    name: filter.name,
                    label: filter.label,
                    displayType: filter.displayType,
                    fieldType: filter.fieldType,
                    value
                  }
              }
            }).filter((filterArg) => !!filterArg);

            const sortFilter = filters.find(filter => filter.name === 'JobPosting.SortCriteria');
            const sortFilterDefaultValue = sortFilter?.filterValues[0]?.value
            const selectedSortFilter = req['sort-by'] || sortFilterDefaultValue
            const extraConfig = sortFilter?.extraConfig || {}


            const sortCriteria = {
              sortField: selectedSortFilter,
              sortOrderAsc: extraConfig[selectedSortFilter] === 'asc' ? true : false
            };

           const location = req['location'];
           const radius = req['within'];
           const latitude = location ? req['location-lat'] : '';
           const longitude = location ? req['location-lng'] : '';


           var locationparam={  location,
             latLong: { latitude, longitude },
             locationType: location ? req['location-type']: '',
             locShortName: location ? req['location-short'] : '',
             radius: radius
           }
           const jobFilters={formattedFilterArgs,sortCriteria,locationparam}
           return jobFilters
          }
           var urlParams = getAllInputValues()
          var paramArray = urlParams.split('&')
          if(paramArray.length>0){
            paramArray.forEach(filter=>{
              const [key,value]=filter.split('=');
              if(key == 'location' || key =='job-search'){
                displayAlerts()
                return null
              }
            })

          }
          async function onJobAlertsSubmit() {
            const jobAlertsEmailInput = document.querySelector('#job-alerts-email-input');
            const termsAndConditions = searchForm.querySelector('#terms')
            const termsAndConditions2 = searchForm.querySelector('#terms2')
            // const smsOptIn = searchForm.querySelector('#smOptIn');
            const jobAlertName = searchForm.querySelector('#job-alerts-name-input')
            var frequency=document.querySelector('input[name="job-alert-frequency"]:checked').value
            jobAlertName.setCustomValidity('');
            if(jobAlertName.value.length<3){
              displayValidationMessage(jobAlertName, __t['jobAlert.nameErrorInvalid']);
              return null;
            }
            else if (!(jobAlertsEmailInput && jobAlertsEmailInput.value && validateEmail(jobAlertsEmailInput.value))) {
                displayValidationMessage(jobAlertsEmailInput, __t['jobAlert.emailErrorInvalid']);
                return null;
            }
            else if(termsAndConditions && !termsAndConditions.checked){
              displayValidationMessage(termsAndConditions, __t['jobAlert.termsServiceErrorRequired']);
              return null
            }
            else if(termsAndConditions2 && !termsAndConditions2.checked){
              displayValidationMessage(termsAndConditions2, __t['jobAlert.termsServiceErrorRequired']);
              return null
            }
            else{
              const filterValues= await getJobAlertFilterParams()
              // var notificationType = {email: true, sms: false, push: false}
              // if(smsOptIn){
              //   notificationType = {email: true, sms: smsOptIn.checked, push: false}
              // }
              const req = {
                email: jobAlertsEmailInput.value,
                name:jobAlertName.value,
                jobAlertFrequency:frequency,
                jobAlertConfigDetails:{jobParamRequests:filterValues.formattedFilterArgs,locationInfo:filterValues.locationparam,sortCriteria:filterValues.sortCriteria,text:""}
                // notificationType: notificationType 
              }
                const response = await createAlerts(req);
            if (!response.success){
             if(response.errorMessage=='You already have an account. Please log in to create a job alert.'){
              searchForm.querySelector('#show-login-error-message').style.display="block"
             }
             else{
              searchForm.querySelector('#show-error-message').innerHTML=response.errorMessage
             }
            //  errorMessage.innerHTML= 'You already have an account. Please'+ <a href="https://google.com">+'log in'+ </a>+'to create a job alert.'
              return null;
            }

            // Track Job Alert Creation
            logWLAnalyticsEvent('Job Alert Created', {
              jobAlertId: response.jobAlertId,
              jobAlertName: jobAlertName.value,
              jobAlertFrequency : frequency,
              loggedIn: false,
            });

            const jobAlertsEmail =  searchForm.querySelector('#job-alerts-email');
            if (jobAlertsEmail) {
                jobAlertsEmail.innerHTML = jobAlertsEmailInput.value;
            }
            const jobAlertsForm = searchForm.querySelector('.job-alerts__card.form');
            const jobAlertsSuccess = searchForm.querySelector('.job-alerts__card.hidden');
            jobAlertsForm.classList.add('hidden');
            jobAlertsSuccess.classList.remove('hidden');
            if (jobAlertsEmail && jobAlertsEmailInput) {
              jobAlertsEmail.innerHTML = jobAlertsEmailInput.value;
            }

          jobAlertsEmailInput.value = '';
          if(termsAndConditions){
            termsAndConditions.checked = false;
          }
          if(termsAndConditions2){
            termsAndConditions2.checked =false;
          }
          jobAlertName.value = __t['jobAlert.nameDefaultValue']
           searchForm.querySelector('#dailyRadio').checked=true;
        }

          }

          function onFinishJobAlerts() {
            onCloseJobAlertsModal();
            jobAlertsToggle.classList.add('hidden');
            const jobAlertsLabel = searchForm.querySelector('#job-alerts-label');
            if (jobAlertsLabel) {
              jobAlertsLabel.innerHTML = __t['jobSearch.alerts.saved'];
            }
          }
          function validateEmail(email) {
            return String(email)
              .toLowerCase()
              .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              );
          };
          function displayValidationMessage(field, message){
            try {
              field.setCustomValidity(message || __t['global.requiredField']);
              field.reportValidity();
            } catch (err) {
              console.log(err);
            }
          }


          document.addEventListener('click', function (e) {
            if (!e.target.closest('.job-search__filters__switch')) {
              onCloseJobAlertsModal();
            }
          });
        }
      }
    }
  }
}
